/**
 * Covers the following cases:
 * 1231231234
 * 123-123-1234
 * 123 123 1234
 * 123 - 123 - 1234
 * (123) 123-1234
 */
export const validatePhoneNumber = (input) => {
  const PHONE_NUMBER_REGEXP = /^\s*\(?\s*\d{3}\s*\)?\s*-?\s*\d{3}\s*-?\s*\d{4}\s*$/;
  return input && input.length && PHONE_NUMBER_REGEXP.test(input);
};


export const cleanInput = (input) => {
  return input.replace(/[^\d]/g, '');
};


export const statuses = {
  INITIAL: 'statuses.INITIAL',
  SENDING: 'statuses.SENDING',
  ERROR: 'statuses.ERROR',
  SUCCESS: 'statuses.SUCCESS',
};



/** WEBPACK FOOTER **
 ** ./shared-components/TextAppForm/utils.js
 **/